export const ARROW_DOWN_KEY_CODE = 40;
export const BACKSPACE_KEY_CODE = 8;
export const DOT_KEY_CODE = 190;
export const ENTER_KEY_CODE = 13;
export const ESCAPE_KEY_CODE = 27;
